/**
 * Agency contact-link helpers (phone / email / website).
 *
 * Every contact link across the header, sidebar and footer builds its href and
 * opens externally in the same way — these helpers keep that consistent (and, for
 * `EXTERNAL_LINK`, safe) instead of repeating the logic at each call site.
 */

/**
 * Spread onto any `<a>` that navigates off-site. Opens a new tab and drops the
 * `window.opener` reference so the target page can't script back into ours.
 * Usage: `<a href={...} {...EXTERNAL_LINK}>`
 */
export const EXTERNAL_LINK = { target: '_blank', rel: 'noopener noreferrer' };

/**
 * NOTE: only spread EXTERNAL_LINK onto real off-site page links (website). Do NOT
 * use it on `tel:` / `mailto:` links — those are app-scheme handoffs, not pages.
 * On iOS Safari a `target="_blank"` mailto/tel triggers a "wants to open…" popup
 * and then opens a blank tab instead of handing off to Mail/the dialler. They
 * should navigate in the same tab (no target).
 */

/** `tel:` href — strips spaces so the dialler receives clean digits. */
export const telHref = (phone) => `tel:${String(phone).replace(/\s+/g, '')}`;

/** `mailto:` href. */
export const mailtoHref = (email) => `mailto:${email}`;

/**
 * Website href. The feed may send a scheme-less address ("www.example.com");
 * force `https://` so the link is absolute (a scheme-less href would otherwise
 * resolve relative to the current page).
 */
export const websiteHref = (url) => (/^https?:\/\//i.test(url) ? url : `https://${url}`);
